import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import animateScrollTo from 'animated-scroll-to';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import IconButton from 'components/common/IconButton';
import Button from 'components/common/Button';
import Link from 'components/common/Link';
import IconMenu from 'components/icons/IconMenu';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  button: {
    minWidth: 160,
    [theme.breakpoints.only('sm')]: {
      minWidth: 210,
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 130,
      fontSize: pxToRem(12),
      lineHeight: pxToEm(18, 12),
    },
  },
  link: {
    display: 'none',
    marginRight: 30,
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  buttonMenu: {
    display: 'block',
    marginRight: 8,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  iconMenu: {
    width: 20,
    height: 20,
  },
});

const LandingHeaderNavigation = ({
  className,
  history,
  location,
  onMenuButtonClick,
  classes,
}) => {
  const scrollOptions = {
    offset: -74,
  };
  return (
    <Toolbar
      disableGutters
      className={className}
    >
      <IconButton
        className={classes.buttonMenu}
        onClick={onMenuButtonClick}
        tooltipContent="Settings"
        target="_blank"
      >
        <IconMenu className={classes.iconMenu} />
      </IconButton>
      <Link
        className={classes.link}
        color="secondary"
        href="tel:877-728-5848"
      >
        877-728-5848
      </Link>
      <Link
        className={classes.link}
        size="md"
        color="secondary"
        onClick={() => {
          history.push('/#features');
          if (location.pathname === '/') {
            animateScrollTo(document.querySelector('#features'), scrollOptions);
          }
        }}
      >
        Features
      </Link>
      <Link
        className={classes.link}
        size="md"
        color="secondary"
        onClick={() => {
          history.push('/#reviews');
          if (location.pathname === '/') {
            animateScrollTo(document.querySelector('#reviews'), scrollOptions);
          }
        }}
      >
        Reviews
      </Link>
      <Link
        className={classes.link}
        size="md"
        color="secondary"
        href="/faq"
      >
        FAQ
      </Link>
      <Link
        className={classes.link}
        size="md"
        color="secondary"
        href="/blog"
      >
        Blog
      </Link>
      <Link
        className={classes.link}
        size="md"
        color="secondary"
        href="/account/login"
        target="_blank"
      >
        Sign In
      </Link>
      <Button
        className={classes.button}
        variant="raised"
        color="primary"
        disableShadow
        href="/account/sign-up"
        target="_blank"
      >
        Try For Free
      </Button>
    </Toolbar>
  );
};

LandingHeaderNavigation.propTypes = {
  className: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  onMenuButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    iconMenu: PropTypes.string.isRequired,
  }).isRequired,
};

LandingHeaderNavigation.defaultProps = {
  className: '',
  onMenuButtonClick: () => {},
};

export default withRouter(
  withStyles(styles)(LandingHeaderNavigation),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/LandingHeader/LandingHeaderNavigation.js